import React from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';


export default function HtmlParser({ html }) {
    return (
        <>
            {ReactHtmlParser(html)}
        </>
    )
}

HtmlParser.propTypes = {
    /** HTML snippet to be rendered */
    html: PropTypes.string.isRequired
};
